<template>
  <span class="ec-spinner" :class="'ec-spinner--' + size">
    <i class="el-icon-loading"></i>
  </span>
</template>

<script>
export default {
  name: 'EcSpinner',
  props: {
    size: { type: String, default: 'md' },
  },
}
</script>

<style scoped>
.ec-spinner { display: inline-flex; align-items: center; }
.ec-spinner--sm i { font-size: 14px; }
.ec-spinner--md i { font-size: 20px; }
.ec-spinner--lg i { font-size: 28px; }
</style>
